// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__minervaModern_578398', '__minervaModern_Fallback_578398'"},"className":"__className_578398","variable":"__variable_578398"};